import React from 'react'
import AutoMailPanel from 'components/dataTable/AutoMailPanel'
import useGenericModal from './useGenericModal'

const useAutoMailModal = () => {
  const { DisplayedModal, setOpenModal, openModal } = useGenericModal({
    customStyle: {
      width: 500,
      height: 450,
    },

    handleKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Escape') {
        setOpenModal(false)
      }
      if (e.key === 'Enter') {
        e.preventDefault()
        setOpenModal(false)
      }
    },
  })

  const AutoMailModal = () => {
    return (
      <DisplayedModal>
        <AutoMailPanel setOpen={setOpenModal} />
      </DisplayedModal>
    )
  }
  return {
    setOpenModal,
    openModal,
    AutoMailModal,
  }
}

export default useAutoMailModal
